module.exports = __webpack_public_path__ + "img/cardbg.88371887.jpg";